import type { HTMLProps } from 'react';
import { Typography } from '../../../typography';
import { TD } from '../td/td';
import styles from './tr.module.scss';

export function TRGroup({ children, ...rest }: HTMLProps<HTMLTableRowElement>) {
  return (
    <tr className={styles.tr} {...rest}>
      <TD showSkeleton={false} style={{ width: '100%' }}>
        <Typography lineHeight="1.5rem" size="0.75rem" transform="uppercase" weight="bold">
          {children}
        </Typography>
      </TD>
    </tr>
  );
}
